/**
 * @description
 */

import Api from '../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

interface IInput {
    element_id: number;
}

export const getElementInfo = (data: IInput): Promise<IResponse<IElementInfo>> => {
    const api = Object.assign({}, Api.GET_ELEMENT_INFO);
    api.url += '/' + data.element_id;
    return fetchData(api).then((res: IResponse<IElementInfo>) => {
        return res;
    });
};

export const getElementInfoSync = fetchDataSync(getElementInfo);
